export const MAINT_TYPE_REPAIRS = "REPARACIONES"
export const MAINT_TYPE_PAINT = "CHAPA_PINTURA"
export const MAINT_TYPE_EQ = "EQUIPAMIENTO"
export const MAINT_TYPE_SERVICE = "SERVICE"
export const ROLE_CHOFER = "CHOFER"
export const ROLE_BASE = "LIDER_BASE"
export const ROLE_FLOTA = "RESPONSABLE_FLOTA"
export const REMARKS_KM = "KILOMETROS"
export const REMARKS_DOMAIN = "DOMINIO"
export const TK_STATUS_AUTHORIZED = "AUTORIZADA"
export const TK_STATUS_REJECTED = "RECHAZADA"
export const TK_STATUS_PENDING = "PENDIENTE"

